import React from 'react';
import Localize from './Localize';

class Page extends Localize {

    constructor(props) {
        super(props)

        this.contentParser = this.contentParser.bind(this);
    }


    contentParser(id) {
        var content = this.props.Content;
        var x, y;
        var textElement;
        var mainContent;


        for (x = 0; x < content.length; ++x) {
            if (typeof(content[x].content) !== "undefined") {
                for (y = 0; y < content[x].content.length; ++y) {
                    if (content[x].content[y].id === id) {
                        mainContent = content[x].content[y]
                        textElement = this.applySettings(mainContent)

                        // If URL, do not alter
                        if (mainContent.hasOwnProperty('class') && mainContent.class === 'url') {
                            return textElement;
                        }

                        // If text is allowed to wrap, do not replace last space with non-breaking space
                        if (!mainContent.hasOwnProperty('class') || mainContent.class !== 'canWrap') {
                            textElement = textElement.replace(/\s(?=[^\s]*$)/g, String.fromCharCode(160))
                        }

                        textElement = textElement.split('\n').map((item,i)=> <span key={i}>{item} <br/></span>);
                        return textElement

                    }
                }
            } else {
                if (content[x].id === id) {
                    mainContent = content[x];
                    textElement = this.applySettings(mainContent)

                    // If URL, do not alter
                    if (mainContent.hasOwnProperty('class') && mainContent.class === 'url') {
                        return textElement;
                    }

                    // If text is allowed to wrap, do not replace last space with non-breaking space
                    if (!mainContent.hasOwnProperty('class') || mainContent.class !== 'canWrap') {
                        textElement = textElement.replace(/\s(?=[^\s]*$)/g, String.fromCharCode(160))
                    }

                    textElement = textElement.split('\n').map((item,i)=> <span key={i}>{item} <br/></span>);
                    return textElement
                }
            }
        }
        return "Content Placeholder.";

    }
    render(){
        return(
            null
        );

    }

}

export default Page;



// WEBPACK FOOTER //
// ./src/components/Page.js